import { fetchCurrentIdToken } from "./util/login";

// Map Amplify v5 auth mode values to v6 format
const AUTH_MODE_MAP = {
  'AMAZON_COGNITO_USER_POOLS': 'userPool',
  'API_KEY': 'apiKey',
  'AWS_IAM': 'iam',
  'OPENID_CONNECT': 'oidc',
  'AWS_LAMBDA': 'lambda',
};

function resolveAuthMode(authType) {
  if (!authType) return 'userPool';
  return AUTH_MODE_MAP[authType] || authType;
}

const graphqlRegion = import.meta.env.VITE_API_REGION || import.meta.env.VITE_API_URL?.match(/\.([a-z]+-[a-z]+-\d+)\./)?.[1] || 'us-east-2';

const apiConfig = {
  Auth: {
    Cognito: {
      userPoolClientId: import.meta.env.VITE_AWS_USER_POOLS_WEB_CLIENT_ID,
      userPoolId: import.meta.env.VITE_AWS_USER_POOLS_ID,
      loginWith: {
        oauth: {
          domain: import.meta.env.VITE_OAUTH_DOMAIN,
          scopes: ['openid', 'profile', 'aws.cognito.signin.user.admin'],
          redirectSignIn: [import.meta.env.VITE_SIGNIN],
          redirectSignOut: [import.meta.env.VITE_SIGNOUT],
          responseType: 'code',
        },
        username: 'true',
        email: 'false',
        phone: 'false',
      }
    }
  },
  API: {
    GraphQL: {
      endpoint: import.meta.env.VITE_API_URL,
      region: graphqlRegion,
      defaultAuthMode: resolveAuthMode(import.meta.env.VITE_API_AUTHTYPE)
    },
    Events: {
      endpoint: import.meta.env.VITE_API_EVENTS_URL,
      region: graphqlRegion,
      defaultAuthMode: resolveAuthMode(import.meta.env.VITE_API_AUTHTYPE)
    }
  },
  Analytics: { disabled: true }
};

const libraryOptions = {
  API: {
    GraphQL: {
      headers: async () => ({
        Authorization: await fetchCurrentIdToken()
      })
    },
    Events: {
      headers: async () => ({
        Authorization: await fetchCurrentIdToken()
      })
    }
  },
};

export { apiConfig, libraryOptions };
